"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyWeather = void 0;
const DataSignalingInterfaces_1 = require("./DataSignalingInterfaces");
exports.EmptyWeather = {
    nucleusDataType: DataSignalingInterfaces_1.DataMessages.TYPE_WEATHER,
    description: "",
    temp_F: 0,
    temp_C: 0,
    iconUrl: "",
    accuweatherUrl: ""
};
